import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWallUp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-wall-up, align top"><path d="M16.25 11L12 6.75L7.75 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 2.75H4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 21.25L12 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowWallUp;
